import { DigitalBusinessCard } from './dbc.model';

export enum CONTACT_DETAIL {
    PHONE_V2 = 'phone_v2',
    EMAIL_V2 = 'email_v2',
    WEBSITE_V2 = 'website_v2',
    CUSTOM_FIELDS = 'custom_fields',
}

export enum LEAD_COLLECT_TYPE {
    COLLECT_FIRST = 1,
    SHARE_FIRST = 2,
}

export const GOOGLE_FONT_MAPPING = {
    Regular: 400,
    'Semi Bold': 600,
    Bold: 700,
    Medium: 500,
    Light: 300,
};

export enum TYPOGRAPHY_CUSTOMIZATIONS {
    PERSONAL_INFO = 'personal_info',
    COMPANY_DETAILS = 'company_details',
    BIO = 'bio',
    CONTACT_DETAILS = 'contact_details',
    BUTTON = 'button',
}

function getGoogleTypographySpecifics(
    cardData: DigitalBusinessCard,
    attribute: string
) {
    const typographyCustomization = cardData.customizations.typography;
    let googleFontSize = '16px';
    let googleFontColor = '#000000';
    let googleFontWeight = 200;
    let googleFontFamily = 'sans-serif';

    // console.log('typographyCustomization', typographyCustomization.company_details)

    if (typographyCustomization[attribute]?.google_font_size) {
        googleFontSize = `${typographyCustomization[attribute]?.google_font_size}px`;
    }

    if (typographyCustomization[attribute]?.google_font_colour) {
        googleFontColor =
            typographyCustomization[attribute]?.google_font_colour;
    }

    if (typographyCustomization[attribute]?.google_font_style) {
        googleFontWeight = Number(
            `${GOOGLE_FONT_MAPPING[typographyCustomization[attribute].google_font_style]}`
        );
    }

    if (typographyCustomization?.font_family) {
        googleFontFamily = typographyCustomization.font_family;
    }

    return `
    .${attribute} {
        font-family: ${googleFontFamily};
        font-size: ${googleFontSize};
        color: ${googleFontColor};
        font-weight: ${googleFontWeight};
    }
    `;
}

function getCustomTypographySpecifics(
    card,
    attribute: TYPOGRAPHY_CUSTOMIZATIONS
) {
    const typographyCustomization = card.customizations.typography;

    let customFontSize = '16px';
    let customFontColor = '#000000';
    let customFontStyle = 200;
    let customFontFamily = 'sans-serif';

    if (typographyCustomization[attribute]?.custom_font_size) {
        customFontSize = `${typographyCustomization[attribute]?.custom_font_size}px`;
    }

    if (typographyCustomization[attribute]?.custom_font_colour) {
        customFontColor =
            typographyCustomization[attribute]?.custom_font_colour;
    }

    if (typographyCustomization[attribute]?.custom_font_style) {
        customFontStyle = typographyCustomization[attribute]?.custom_font_style;
    }

    if (typographyCustomization?.font_family) {
        customFontFamily = typographyCustomization.font_family;
    }

    return `
        @font-face {
            font-family: '${customFontFamily} - ${customFontStyle}';
            src: url('${typographyCustomization[attribute].custom_font_url}') format('truetype');
        }
        .${attribute} {
            font-family: '${customFontFamily} - ${customFontStyle}', sans-serif;
            font-size: ${customFontSize};
            color : ${customFontColor};
      }`;
}

export function getTypographyStyle(card: DigitalBusinessCard) {
    let typography = '';

    if (card.customizations.typography.font_type === 'custom') {
        typography += `${getCustomTypographySpecifics(card, TYPOGRAPHY_CUSTOMIZATIONS.PERSONAL_INFO)}`;
        typography += `${getCustomTypographySpecifics(card, TYPOGRAPHY_CUSTOMIZATIONS.CONTACT_DETAILS)}`;
        typography += `${getCustomTypographySpecifics(card, TYPOGRAPHY_CUSTOMIZATIONS.COMPANY_DETAILS)}`;
        typography += `${getCustomTypographySpecifics(card, TYPOGRAPHY_CUSTOMIZATIONS.BUTTON)}`;
        typography += `${getCustomTypographySpecifics(card, TYPOGRAPHY_CUSTOMIZATIONS.BIO)}`;
    } else {
        typography += `${getGoogleTypographySpecifics(card, TYPOGRAPHY_CUSTOMIZATIONS.PERSONAL_INFO)}`;
        typography += `${getGoogleTypographySpecifics(card, TYPOGRAPHY_CUSTOMIZATIONS.CONTACT_DETAILS)}`;
        typography += `${getGoogleTypographySpecifics(card, TYPOGRAPHY_CUSTOMIZATIONS.COMPANY_DETAILS)}`;
        typography += `${getGoogleTypographySpecifics(card, TYPOGRAPHY_CUSTOMIZATIONS.BUTTON)}`;
        typography += `${getGoogleTypographySpecifics(card, TYPOGRAPHY_CUSTOMIZATIONS.BIO)}`;
    }

    return typography;
}

export function sortByLatestUpdated(
    a: DigitalBusinessCard,
    b: DigitalBusinessCard
): number {
    const aUpdated = a.updated ? new Date(a.updated).getTime() : 0;
    const bUpdated = b.updated ? new Date(b.updated).getTime() : 0;
    return bUpdated - aUpdated; // Descending order (latest first)
}
